<app-locations-table-molecule></app-locations-table-molecule>